import React from "react";
import PropTypes from "prop-types";
import "./action-button.css";

function ActionButton(props) {
  const { onClick, buttonText } = props;
  return (
    <div
      role="button"
      className="button-Container"
      onClick={onClick}
      onKeyDown={() => {
        // onKeyDown
      }}
      tabIndex="0"
    >
      <a className="actionbutton">
        {" "}
        <span />
        <span>{buttonText}</span>
      </a>
    </div>
  );
}

ActionButton.defaultProps = {
  className: "",
  buttonText: "",
  onClick: () => {
    // onClick
  },
};
ActionButton.propTypes = {
  className: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
};
export default ActionButton;
